import axios from './axios'

const DEDUPE_DEFAULT_MS = 1000
const DEDUPE_BY_TYPE = { COPY_SENSITIVE: 30000 }
const lastSent = {}
let _sessionId = null

function sid() {
  if (_sessionId) return _sessionId
  try {
    _sessionId = (window.crypto && window.crypto.randomUUID && window.crypto.randomUUID())
      || (Math.random().toString(36).slice(2) + Date.now().toString(36))
  } catch (_) {
    _sessionId = Math.random().toString(36).slice(2) + Date.now().toString(36)
  }
  return _sessionId
}

export function reportSecurityEvent(type, metadata) {
  if (!type) return
  const now = Date.now()
  const dedupe = DEDUPE_BY_TYPE[type] || DEDUPE_DEFAULT_MS
  if (lastSent[type] && now - lastSent[type] < dedupe) return
  lastSent[type] = now
  try {
    axios.post('/log/security', {
      type: type,
      path: window.location.pathname + (window.location.hash || ''),
      timestamp: new Date().toISOString(),
      metadata: Object.assign({
        userAgent: navigator.userAgent,
        viewport: { w: window.innerWidth, h: window.innerHeight },
        sessionId: sid(),
        host: window.location.hostname,
        brand: 'vikbet',
      }, metadata || {}),
    }).catch(function () { /* silent */ })
  } catch (e) { /* noop */ }
}
